import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TextFields from '../UI/TextFiled';
import { Form } from 'react-form';
import DatePickerUI from '../UI/DatePicker';

class Saleries extends Component {

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Salaries</h1>
                            </div>
                            <div className="col-xs-3 text-right">
                                <Form onSubmit={ this.submitted }>
                                    { formApi => (
                                        <form onSubmit={formApi.submitForm} className="search">
                                            <TextFields type="text" hintText="Search"/>
                                            <button className="no-style search-btn pointer">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container box py-15">
                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="row">
                                    <div className="col-xs-2">
                                        <DatePickerUI label="From"/>
                                    </div>
                                    <div className="col-xs-2 ml-30">
                                        <DatePickerUI label="To"/>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Form>
                    <div className="table withHover mt-20">
                        <table>
                            <thead>
                                <tr>
                                    <th>Driver ID</th>
                                    <th>Driver First Name</th>
                                    <th>Driver Last Name</th>
                                    <th>Full Time/ Part Time</th>
                                    <th>Number of Deliveries</th>
                                    <th>Salary</th>
                                    <th>Export</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>001</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>Lilit</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>Safaryan</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>Part-time</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>2</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/part/id') }>25 SAR</td>
                                    <td>
                                        <Link to="#"><i className="fa fa-file-pdf-o"></i></Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>002</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>Petros</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>Petrosyan</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>Full-time</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>2</td>
                                    <td onClick={ () => this.props.history.push('/hr/saleries/full/id') }>25 SAR</td>
                                    <td>
                                        <Link to="#"><i className="fa fa-file-pdf-o"></i></Link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Saleries;



// WEBPACK FOOTER //
// ./src/components/Hr/Saleries.js